module.exports = __webpack_public_path__ + "static/media/File.dc60ece5.svg";